const multiClass = (classList) => classList.join(' ');

export { multiClass };
